<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2021-03-22 19:09:00
 * @LastEditors: xiawenlong
 * @LastEditTime: 2021-10-18 16:12:28
-->
<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import * as type from '@/store/action-types'
export default {
  name: 'App',
  mounted() {
    window['phoneBackButtonListener'] = () => !this.$route.meta.homePage
    const device = navigator.userAgent.toLowerCase()
    const isAndroid = device.indexOf('ironge-app') > -1
    this.$store.commit(type.SET_IS_ANDROID, isAndroid)
  },
}
</script>
